window.addEventListener("DOMContentLoaded", () => {
    if (window.innerWidth <= 989) return;
  
    const $horizontalWrapper = document.getElementById("horizontal-wrapper");
    const inner = $horizontalWrapper.querySelector(".scroll_content");
    const artistCopy = document.querySelector('.artist_copy_container');
    const footer = document.getElementById('site-footer');
  
    const updateDimensions = () => {
      const cells = inner.querySelectorAll(".img_cell");
      let totalWidth = 0;
  
      cells.forEach(cell => {
        totalWidth += cell.getBoundingClientRect().width;
      });
  
      inner.style.width = `${totalWidth}px`;
      const scrollDistance = totalWidth - window.innerWidth;
      $horizontalWrapper.style.height = `${scrollDistance + window.innerHeight}px`;
    };
  
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
  
    window.addEventListener("scroll", () => {
      const windowScroll = window.pageYOffset;
      const start = $horizontalWrapper.offsetTop;
      const end = start + $horizontalWrapper.offsetHeight - window.innerHeight;
      const maxScrollX = inner.scrollWidth - window.innerWidth;
  
      let scrollProgress = (windowScroll - start) / (end - start);
      scrollProgress = Math.min(Math.max(scrollProgress, 0), 1);
  
      $horizontalWrapper.className = '';
  
      if (windowScroll >= end) {
        $horizontalWrapper.classList.add('post-sticky');
        inner.style.transform = `translateX(-${maxScrollX}px)`;
        if (footer) footer.classList.add('visible');
      } else if (windowScroll >= start) {
        $horizontalWrapper.classList.add('sticky');
        const offset = scrollProgress * maxScrollX;
        inner.style.transform = `translateX(-${offset}px)`;
        if (footer) footer.classList.remove('visible');
      } else {
        $horizontalWrapper.classList.add('pre-sticky');
        inner.style.transform = `translateX(0px)`;
        if (footer) footer.classList.remove('visible');
      }
  
      // ✅ Artist fade out logic
      if (artistCopy) {
        const fadeStart = 0;
        const fadeEnd = window.innerHeight / 3;
  
        let opacity = 1;
        if (windowScroll >= fadeEnd) {
          opacity = 0;
        } else if (windowScroll > fadeStart) {
          opacity = 1 - (windowScroll - fadeStart) / (fadeEnd - fadeStart);
        }
  
        artistCopy.style.setProperty('opacity', opacity, 'important');
      }
    });
  });
  